export default "__VITE_ASSET__DJrrCpV1__"